import React, {Component, Fragment} from 'react';
import {observer} from "mobx-react";
import Moment from 'react-moment';
import 'moment/locale/ru';

class Datetime extends Component {
  render() {
    if(this.props.value && this.props.value!=='0000-00-00 00:00:00') {
      return (
        <>
          <Moment format={"LL"} locale="ru">{this.props.value}</Moment><br/>
          <Moment format={"LTS"} locale="ru">{this.props.value}</Moment>
        </>
      );
    } else {
      return <span>&ndash;</span>
    }
  }
}

export default observer(Datetime);